import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Component, DestroyRef, inject } from '@angular/core';
import { BusinessService, UserService } from '../../../index';
import { AssignWorkerRole, Business, User } from '../../../models';
import { WorkerRoleService } from '../../../services/worker-role.service';
import { Observable, concatMap, map, startWith } from 'rxjs';
import { signal } from '@angular/core';
import { Cookies } from 'typescript-cookie';
import { ToastAlertService } from '@core/services';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule, FormsModule, FormControl } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ToolbarComponent } from '@shared/components/toolbar/toolbar.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
  selector: 'app-assign-role',
  templateUrl: './assign-role.component.html',
  standalone: true,
  imports: [
    ToolbarComponent,
    MatFormFieldModule,
    MatSelectModule,
    NgFor,
    MatOptionModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    NgIf,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatAutocompleteModule,
    AsyncPipe,
  ],
})
export class AssignRoleComponent {
  public userService = inject(UserService);
  public users!: User[];
  public currentUser!: User;
  public showList: model[] = [];
  public showListSecondary: model[] = [];
  private serviceAttributions = inject(WorkerRoleService);
  private destroyRef = inject(DestroyRef);
  public rol = '';
  public disabled = signal<boolean>(false);
  dataSource: any;
  fielInput!: string;

  private alertService = inject(ToastAlertService);
  private businessService = inject(BusinessService);
  private businessId: number | null | undefined;
  public selectedBussines = -1;
  public bussines: Business[] = [];
  public allSwitchesDisabled = false;
  public allSwitchesDisabledSecundary = false;
  myControl = new FormControl('');

  isRole: boolean = false;
  role() {
    const role = Cookies.get('role');
    if (role && role === 'ADMINISTRADOR') {
      this.isRole = true;
    } else {
      this.isRole = false;
    }
  }
  buscarUsuarios() {
    this.currentUser = {
      worker_id: -1,
      first_name: '',
      last_name: '',
      user_name: '',
      user_code: '',
      email: '',
      secondEmail: '',
      phone: '',
      address: '',
      state: '',
      building_id: '',
      building_name: '',
      workerGroupId: -999,
      workerGroupName: '',
      country_id: -999,
      country_name: '',
      role_id: -999,
      role_name: '',
      parkingBuilding_id: '',
      parkingBuilding_name: '',
    };

    if (this.fielInput) {
      this.users = this.dataSource.filter((user: User) => {
        // Puedes ajustar la lógica de búsqueda según tus necesidades
        return (
          user.user_name.toLowerCase().includes(this.fielInput.toLowerCase()) ||
          user.first_name
            .toLowerCase()
            .includes(this.fielInput.toLowerCase()) ||
          user.last_name.toLowerCase().includes(this.fielInput.toLowerCase())
        );
      });
    } else {
      this.users = this.dataSource;
    }
  }

  constructor() {
    this.role();
    this.getBusiness();

    const business = Cookies.get('bussinesId');
    if (business != null) {
      this.businessId = parseInt(business.toString());
      this.selectedBussines = this.businessId;
      this.storebybusiness();
    } else {
      this.selectedBussines = 1;
      this.businessId = null;
    }

    // UserDefault
    this.currentUser = {
      worker_id: -1,
      first_name: '',
      last_name: '',
      user_name: '',
      user_code: '',
      email: '',
      secondEmail: '',
      phone: '',
      address: '',
      state: '',
      building_id: '',
      building_name: '',
      workerGroupId: -999,
      workerGroupName: '',
      country_id: -999,
      country_name: '',
      role_id: -999,
      role_name: '',
      parkingBuilding_id: '',
      parkingBuilding_name: '',
    };
  }
  private getBusiness() {
    this.businessService
      .getBusiness()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (request: any) => {
          if (request.code === 10000) {
            this.bussines = request.reply;
            this.filteredOptions = this.myControl.valueChanges.pipe(
              startWith(''),
              map(value => this._filter(value))
            );
          }
        },
      });
  }

  storebybusiness() {
    this.userService
      .getUsersByBussines(this.selectedBussines)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((request: any) => {
        if (request.code === 10000) {
          if (request.reply && request.reply.length > 0) {
            const role = Cookies.get('role');

            this.users = request.reply;

            this.dataSource = this.users;
            this.showList = [];
            this.showListSecondary = [];
          }
        } else {
          this.alertService.error('Error en la solicitud: ' + request.detail);
        }
      });
  }

  setCurrentUser(user: User): void {
    this.currentUser = user;
    console.log('Entre');
    if (user) {
      this.loadAttributions();
    }
  }

  debeDeshabilitar(nombre: string): boolean {
    // Evaluación de la condición
    if (nombre === 'SYSADMIN') {
      return true; // Deshabilitar
    } else {
      return false; // No deshabilitar
    }
  }
  ValidBusiness_id(): boolean {
    return this.businessId === null;
  }

  loadAttributions() {
    this.showList = [];
    this.showListSecondary = [];

    this.serviceAttributions
      .getRoleAssigned(this.currentUser.worker_id as number)
      .pipe(
        concatMap((assignedRoles: any) => {
          if (assignedRoles.code === 10000) {
            for (const item of assignedRoles.reply) {
              const element: model = {
                role: item,
                state: true,
              };
              this.rol = element.role.name;
              if (
                element.role.name !== 'CLIENTE' &&
                element.role.name !== 'CLIENTE-PARQUEO'
              ) {
                this.showList.push(element);
              } else {
                this.showListSecondary.push(element);
              }
            }
          }
          // Retorna el segundo observable para la siguiente suscripción
          return this.serviceAttributions.getRoleNotAssigned(
            this.currentUser.worker_id as number
          );
        })
      )
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (notAssignedRoles: any) => {
          if (notAssignedRoles.code === 10000) {
            for (const item of notAssignedRoles.reply) {
              const element: model = {
                role: item,
                state: false,
              };
              if (
                this.rol !== 'SYSADMIN' &&
                element.role.name !== 'SYSADMIN' &&
                this.rol !== 'ACCESOS' &&
                element.role.name !== 'ACCESOS'
              ) {
                if (
                  element.role.name !== 'CLIENTE' &&
                  element.role.name !== 'CLIENTE-PARQUEO'
                ) {
                  this.showList.push(element);
                } else {
                  this.showListSecondary.push(element);
                }
              }
            }
          }
          console.log(
            'Validando, ',
            !this.showList.every(item => item.state === false)
          );
          this.allSwitchesDisabled = !this.showList.every(
            item => item.state === false
          );
          this.allSwitchesDisabledSecundary = !this.showListSecondary.every(
            item => item.state === false
          );
        },
      });
  }
  shouldDisableSwitch(val: model): boolean {
    const userRole = Cookies.get('role');

    return (
      ((val.role.name === 'ADMINISTRADOR' && userRole !== 'SYSADMIN') ||
        this.debeDeshabilitar(val.role.name) ||
        val.state === false) &&
      this.allSwitchesDisabled
    );
  }
  shouldDisableSwitchSegundary(val: model): boolean {
    return (
      (this.debeDeshabilitar(val.role.name) || val.state === false) &&
      this.allSwitchesDisabledSecundary
    );
  }

  changeState(element: model) {
    console.log('data', element);
    // Deshabilitar los demás interruptores
    this.showList.forEach(item => {
      if (item !== element) {
        item.state = false;
      }
    });

    this.showListSecondary.forEach(item => {
      if (item !== element) {
        item.state = false;
      }
    });
    // Verificar si el rol es "Administrador"

    if (element.role.worker_role_id) {
      this.serviceAttributions
        .deleteRoleAsssignment(element.role.worker_role_id)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(() => {
          this.loadAttributions();
        });
    } else {
      this.serviceAttributions
        .storeRoleAssigment(
          this.currentUser.worker_id as number,
          element.role.role_id
        )
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe({
          next: resp => {
            if (resp.code === 10000) {
              this.loadAttributions();
            } else {
              this.alertService.error(resp.detail);
              this.loadAttributions();
            }
          },
        });
    }
  }

  filteredOptions: Observable<Business[]> = new Observable<Business[]>(
    observer => {
      observer.next([]);
    }
  );
  public selectedBussinesName = '';

  onOptionSelected(value: number, name: string) {
    this.selectedBussines = value;
    this.selectedBussinesName = name;
    this.myControl.setValue(this.selectedBussinesName);
    this.applyFilter();
  }

  applyFilter() {
    const value = this.myControl.value;
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(value),
      map(value => this._filter(value))
    );
  }

  removeDiacritics(text: string): string {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  private previousSearchValue: string | null = null;
  private _filter(value: string | null): Business[] {
    const filterValue = (value || '').toLowerCase();
    // Actualiza el valor de búsqueda anterior
    if (!filterValue) {
      return this.bussines;
    }
    return this.bussines.filter(
      bussines =>
        this.removeDiacritics(bussines.name.toLowerCase()).includes(
          this.removeDiacritics(filterValue)
        ) ||
        (bussines.idBusiness !== undefined &&
          bussines.idBusiness.toString().includes(filterValue))
    );
  }

  selectedOptionTemp = '';
  optionSelected(option: string) {
    this.selectedOptionTemp = option;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}

interface model {
  role: AssignWorkerRole;
  state: boolean;
}
